import React from 'react';
import { DynamicComponent } from 'ctm-components';
import { PolicyCompareDrawerComponent } from './compare_drawer';

const PolicyCompareDrawer = () => <DynamicComponent component={<PolicyCompareDrawerComponent />} />;

export { PolicyCompareDrawer };
